// Other
import { inject, observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { WorkPageWrapper } from './TextDistributionProductsStylePage'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import DistributionVotesCreate from './DistributionVotesCreate'
import DistributionVotesList from './DistributionVotesList'
import {
  AddCircleOutlineIcon,
  MagnifierOutlineIcon,
} from '../../components/AppIcon'
// Ant design
import { Button, Input, Modal } from 'antd'

// Component
import { ACL_ACTION_TYPE } from '../../constants'
// Other
import AccessControlAction from '../../components/AccessControlAction'
import DistributionVotesListAdvanceFilterV2 from './DistributionVotesListAdvanceFilterV2'
import queryString from 'query-string'
import AppPageHeader from '../../components/AppPageHeader'
import { useHistory, useLocation } from 'react-router-dom'

const DistributionVotesPage = props => {
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)

  const history = useHistory()
  const location = useLocation()

  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )
  const handleToggleCreateModal = bool => event => {
    props.managementAssetWarehouseStore.clearManagementAssetWarehouseDetail()
    setIsVisibleCreateModal(bool)
    // DistributionVotesStore.clearFilterProposal()
  }

  const onSearchProposal = values => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        keyword: values?.trim() || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/distribution-votes?${queryStringStringify}`)
  }

  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Phiếu phân phát văn phòng phẩm</title>
        </Helmet>

        <AppPageHeader
          title="Phiếu phân phát văn phòng phẩm"
          addon={
            <>
              <Input.Search
                allowClear
                onSearch={onSearchProposal}
                defaultValue={queryStringParse?.keyword}
                maxLength={500}
                placeholder="Tìm kiếm theo nội dung"
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
              />
              <DistributionVotesListAdvanceFilterV2 />
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.create__PROPOSAL__ASSET}>
                <Button
                  type={'primary'}
                  className="custom-ant-button icon-btn "
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={handleToggleCreateModal(true)}>
                  Tạo mới
                </Button>
              </AccessControlAction>
            </>
          }
        />
        <DistributionVotesList
          {...props}
          isVisibleCreateModal={isVisibleCreateModal}
        />

        <Modal
          width="100dvw"
          style={{ top: 30 }}
          title={'Thêm mới'}
          visible={isVisibleCreateModal}
          maskClosable={false}
          onCancel={handleToggleCreateModal(false)}
          footer={null}
          destroyOnClose
          wrapClassName="custom-modal-wrapper">
          {isVisibleCreateModal && (
            <DistributionVotesCreate
              onCancel={handleToggleCreateModal(false)}
            />
          )}
        </Modal>
      </DashboardLayout>
    </WorkPageWrapper>
  )
}

export default inject(
  'DistributionVotesStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'managementAssetWarehouseStore'
)(observer(DistributionVotesPage))
